module.exports = __webpack_public_path__ + "img/qixi_activity_middle.f97f5d75.jpg";